@if (canShow) {
  <div class="display-flex hdw-paginator hdw-paginator-alignment">
    @if (canShowJumpToStart()) {
      <button
        class="jump-to-start usa-button--unstyled hdw-paginator-item"
        aria-label="Jump to Start"
        (click)="handleJumpToStart()"
      >
        <i class="fa fa-backward-step font-size-rem-1-point25"></i>
      </button>
    }
    @if (selectedIndex > 0) {
      <button class="back-button usa-button--unstyled hdw-paginator-item" aria-label="Back" (click)="handleBack()">
        <i class="fa-solid fa-chevron-left font-size-rem-1-point25"></i>
      </button>
    }
    @for (pageItem of pagesToRender; track pageItem) {
      <button
        class="page-button usa-button--unstyled font-ui-sm text-no-underline hdw-paginator-item"
        [attr.aria-label]="'Page ' + pageItem"
        (click)="handlePageClick(pageItem)"
        [ngClass]="{ 'page-selected': pageItem - 1 === selectedIndex }"
      >
        {{ pageItem }}
      </button>
    }
    @if (selectedIndex < totalPages - 1) {
      <button class="next-button usa-button--unstyled hdw-paginator-item" aria-label="Next" (click)="handleNext()">
        <i class="fa-solid fa-chevron-right font-size-rem-1-point25"></i>
      </button>
    }
    @if (canShowJumpToEnd()) {
      <button
        class="jump-to-end usa-button--unstyled hdw-paginator-item-last"
        aria-label="Jump to End"
        (click)="handleJumpToEnd()"
      >
        <i class="fa fa-forward-step font-size-rem-1-point25"></i>
      </button>
    }
  </div>
}
